import {
  Children,
  ComponentPropsWithRef,
  ReactElement,
  ReactNode,
  isValidElement,
} from "react";
import styled from "styled-components";
import {
  AdminInfoResponse,
  App,
  UserInfoResponse,
  fullRoutes,
} from "@songtradr-sso/shared/common";
import {
  DropdownItem,
  maxSmall,
  shade0,
  shade800,
  shade1000,
} from "@songtradr/design-language";
import { staticText } from "../../statics/static-text";
import { redirect } from "../../utils/navigation.utils";

// TEXT
export const text = staticText.components.appNavigation;

// STYLES
export const Navbar = styled.div<Pick<Props, "$height">>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${shade800};
  min-height: ${({ $height }) => $height};
  background-color: ${shade1000};
  padding: 0 2rem;

  @media ${maxSmall} {
    padding: 0 1rem;
  }
`;

export const LogoLink = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  width: max-content;
  flex: 0 0 auto; /* Do not grow or shrink, size based on content */

  &:focus-visible {
    box-shadow: inset 0 0 0 1px ${shade0};
  }
`;

export const UserInfo = styled(DropdownItem)`
  pointer-events: none;
`;

// DATA

// TYPES
export type ContextShape = UserInfoResponse | AdminInfoResponse;

export interface Props<T = ContextShape> extends ComponentPropsWithRef<"div"> {
  logo: ReactElement<ComponentPropsWithRef<"svg">>;
  contextHook: () => T;
  $height: string;
  onSignOut?: () => void;
}

// CONSTANTS

// FUNCTIONS
export const redirectToSignOut = () => redirect(fullRoutes[App.Core].signOut);

export const filterChildren = (children: ReactNode) => {
  const allChildren = Children.toArray(children);
  const dropdownChildren = allChildren.filter(
    (c) => isValidElement(c) && c.type === DropdownItem,
  );
  const primaryChildren = allChildren.filter(
    (c) => !(isValidElement(c) && c.type === DropdownItem),
  );

  return { primaryChildren, dropdownChildren };
};

export const openJwtWindow = (payload: string | undefined) => {
  if (payload) {
    const newWindow = window.open("about:blank", "_blank");
    if (newWindow) {
      const doc = newWindow.document;
      const html = doc.createElement("html");
      const body = doc.createElement("body");
      const pre = doc.createElement("pre");
      pre.textContent = JSON.stringify(JSON.parse(payload), null, 2);
      body.appendChild(pre);
      html.appendChild(body);
      doc.replaceChild(html, doc.documentElement);
    }
  }
};

// ASSETS
